export default __webpack_public_path__ + "static/media/dashboard.9df7aca5.webp";